/**
 * Created by Arif Topcu in 2019
 */

import React, { memo, useMemo } from "react";
import PropTypes from "prop-types";
import "./style.css";
import Combobox from "@ls/react-combobox-grid";
import { Cell, Grid } from "styled-css-grid";
import CovarianceType from "state/selections/Constants/CovarianceType";
import {
  selectBetaDecodesSelectionOptions,
  selectFetchingBetaDecodes,
} from "state/betas/selectors";
import { useSelector } from "react-redux";
import { summaryTypeOptionsLegacy } from "state/selections/Constants/SummaryType";
import { selectFactribTypes } from "state/factrib/selectors";

const covarianceOptions = Object.values(CovarianceType);

const BetaSelectorComplication = ({ setDefinition, definition }) => {
  const factribTypes = useSelector(selectFactribTypes);
  const betaDecodesSelectionOptions = useSelector(
    selectBetaDecodesSelectionOptions
  );
  const fetchingBetaDecodes = useSelector(selectFetchingBetaDecodes);

  const [setBetaId, setCovarianceType, setSummary, setBetaValue] =
    useMemo(() => {
      return [
        (value) => setDefinition(definition.setBetaId(value)),
        (value) => setDefinition(definition.setCovarianceType(value)),
        (value) => setDefinition(definition.setSummary(value)),
        (value) => setDefinition(definition.setBetaValue(value)),
      ];
    }, [definition, setDefinition]);

  const factribTypeOptions = useMemo(
    () =>
      factribTypes //should be filtered according to Heather I. "Currency, Spread, Yield and Total would be the factors for betas."
        .filter(
          (val) =>
            val === "CURRENCY" ||
            val === "SPREAD" ||
            val === "YIELD" ||
            val === "TOTAL"
        )
        .map((val) => ({ label: val, value: val })),
    [factribTypes]
  );
  return (
    <Grid columns={3} gap="4px">
      <Cell width={3}>
        <Combobox
          label="Beta:"
          labelPosition={"TOP"}
          value={definition.betaId}
          options={betaDecodesSelectionOptions}
          loading={fetchingBetaDecodes}
          placeholder="Select Beta..."
          onChange={setBetaId}
          size={"S"}
          variation={0}
        />
      </Cell>
      <Cell>
        <Combobox
          label="Covariance Type:"
          labelPosition={"TOP"}
          value={definition.covarianceType}
          options={covarianceOptions}
          placeholder="Select Covariance..."
          onChange={setCovarianceType}
          gridHeight={100}
          clearable={false}
          size={"S"}
          variation={0}
        />
      </Cell>
      <Cell>
        <Combobox
          label="Value:"
          labelPosition={"TOP"}
          value={definition.betaValue}
          options={factribTypeOptions}
          onChange={setBetaValue}
          gridHeight={100}
          clearable={false}
          size={"S"}
          variation={0}
        />
      </Cell>
      <Cell>
        <Combobox
          options={summaryTypeOptionsLegacy}
          onChange={setSummary}
          value={definition.summary}
          label="Abs/Rel:"
          clearable={false}
          variation={0}
          size={"S"}
          gridHeight={100}
        />
      </Cell>
    </Grid>
  );
};

BetaSelectorComplication.propTypes = {
  setDefinition: PropTypes.func.isRequired,
  definition: PropTypes.object.isRequired,
};

export default memo(BetaSelectorComplication);
